<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>网上报名设置 </BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">网上报名设置</div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="展区管理" name="1"> </TabPane>
        <TabPane label="商品管理" name="2"> </TabPane>
        <TabPane label="商品分组管理" name="3"> </TabPane>
        <TabPane label="展团管理" name="4"> </TabPane>
      </Tabs>
      <!-- <div class="searchPro">
        <Button type="error" style="margin-left: 20px" @click="setTimes"
          >展讯通提交时间设置</Button
        >
      </div> -->
      <div class="searchPro">
        <div
          class="htb-item"
          @click="synchronous(1)"
          v-if="showTabs != '3' && showTabs != '4'"
        >
          <i class="icon iconfont icon-downLoad2"></i>
          <span>同步慕渊云展区 </span>
        </div>
        <div class="htb-item" @click="synchronous(2)" v-if="showTabs == '3'">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>添加 </span>
        </div>
      </div>
    </div>

    <div class="layout-content" style="background: transparent">
      <!-- <div v-if="list.length"> -->
      <div>
        <areaPage ref="areaClick" v-if="showTabs == '1'"></areaPage>
        <group ref="groupClick" v-if="showTabs == '2'"></group>
        <merchandise
          ref="merchandiseClick"
          v-if="showTabs == '3'"
        ></merchandise>
        <productGrouping v-if="showTabs == '4'"></productGrouping>
      </div>
    </div>
  </div>
</template>
  
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import areaPage from "../components/area.vue";
import group from "../components/group.vue";
import merchandise from "../components/merchandise.vue";
import productGrouping from "../components/productGrouping.vue";

export default {
  name: "exhibition-info-carApply",
  data() {
    return {
      newsAudit: "0",
      productTypeOptions: [
        {
          value: "选项1",
          label: "黄金糕",
        },
      ],
      productTypeValue: "",
      dialogCl: false,
      modalDetail: false,
      loading: false,
      dialogPl: false,
      rejectValuePl: "",

      editBrand: false,
      editBrandnfo: null,
      editTopic: false,
      editTopicnfo: null,
      search: "",
      editInfo: null,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      CompanyName: "",
      valueTime: "",
      columns: [
        {
          title: "公司",
          slot: "companyName",
          align: "center",
        },
        {
          title: "主开通人",
          slot: "name",
          align: "center",
        },
        {
          title: "手机",
          slot: "phoneNumber",
          align: "center",
        },
        {
          title: "邮箱",
          slot: "email",
          align: "center",
        },
        {
          title: "证件类型",
          slot: "idType",
          align: "center",
        },
        {
          title: "证件号",
          slot: "idNumber",
          align: "center",
        },
        {
          title: "部门",
          slot: "department",
          align: "center",
        },
        {
          title: "职务",
          slot: "jobTitle",
          align: "center",
        },
        {
          title: "次开通人",
          slot: "cPeople",
          align: "center",
        },
        {
          title: "订单数",
          slot: "number",
          align: "center",
        },
        {
          title: "开通说明",
          slot: "firstFileUrl",
          align: "center",
        },
        {
          title: "提交时间",
          slot: "upTime",
          align: "center",
        },
        {
          title: "状态",
          slot: "state",
          align: "center",
        },
        {
          title: "操作",
          slot: "isdeal",
          align: "center",
        },
      ],
      columnsNoHandel: [
        {
          title: "公司",
          slot: "companyName",
          align: "center",
        },
        {
          title: "主开通人",
          slot: "name",
          align: "center",
        },
        {
          title: "手机",
          slot: "phoneNumber",
          align: "center",
        },
        {
          title: "邮箱",
          slot: "email",
          align: "center",
        },
        {
          title: "证件类型",
          slot: "idType",
          align: "center",
        },
        {
          title: "证件号",
          slot: "idNumber",
          align: "center",
        },
        {
          title: "部门",
          slot: "department",
          align: "center",
        },
        {
          title: "职务",
          slot: "jobTitle",
          align: "center",
        },
        {
          title: "次开通人",
          slot: "cPeople",
          align: "center",
        },
        {
          title: "订单数",
          slot: "number",
          align: "center",
        },
        {
          title: "变更资料说明",
          slot: "fileUrl",
          align: "center",
        },
        {
          title: "提交时间",
          slot: "upTime",
          align: "center",
        },

        {
          title: "操作",
          slot: "isdeal",
          align: "center",
        },
      ],
      columnsp: [
        {
          title: "主开通人",
          slot: "name",
          align: "center",
        },
        {
          title: "手机",
          slot: "phoneNumber",
          align: "center",
        },
        {
          title: "邮箱",
          slot: "email",
          align: "center",
        },
        {
          title: "部门",
          slot: "department",
          align: "center",
        },
        {
          title: "职务",
          slot: "jobTitle",
          align: "center",
        },
      ],
      oppTime: [],
      searchField: "",
      list: [],
      list2: [],
      selection: [], // 选中项目
      addShow: false,
      rejectModel: false,
      modelTitle: "",
      rowUser: {},
      optOld: {},
      showTabs: "1",
      PoptipTitle: "",
      option: {},
      stateInit: "",
      rejectValue: "",
      currentEmail: "",
      type: [],
      idCategory: "",
      proIdType: "fcb459d0-9565-413b-832d-f25bba4c3567",
      statusProType: ["wait"],
      timeShow: false,
      setTime: {
        startTime: "",
        endTime: "",
        exhibitionId: "",
      },
    };
  },
  components: {
    areaPage,
    group,
    merchandise,
    productGrouping,
    // exhibitionCarNo
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
      exhibitionId: "hostSetModule/getHostExhibition",
    }),
  },
  created() {
    document.title = "网上报名设置";
  },
  // mounted() {
  //   this.showTabs = "1";
  //   this.$refs.areaClick.init();
  // },
  methods: {
    ...mapActions({
      getExhibitionCommodity: "hostManage/getExhibitionCommodity",
      getExhibitionArea: "hostManage/getExhibitionArea",
    }),
    async synchronous(index) {
      if (index == 1) {
        let opt = {
          exhibitionId: this.exhibitionId.id,
        };
        let proData = await this.getExhibitionArea(opt);
        let proData1 = await this.getExhibitionCommodity(opt);
        if (this.showTabs == 1) {
          this.$refs.areaClick.init1();
        } else {
          this.$refs.groupClick.init1();
        }
      } else {
        this.$refs.merchandiseClick.detailNumbers();
      }
    },
    switchBrand(name) {},
  },
};
</script>
  
<style scoped lang="scss">
.required {
  color: red;
  margin-right: 4px;
}
.header-tabs {
  // display: flex;
  position: relative;
}
.searchPro {
  position: absolute;
  right: 24px;
  top: -55px;
}
.htb-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 150px;
  height: 80px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #fff;
  border: 2px dotted #d13119;
  color: #d13119;
  background: #ffe6e3;
  margin-left: 20px;
  cursor: pointer;
}
.catalogue {
  .header-tool {
    min-height: 90px;
  }

  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}

.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}

.spanClass {
  margin-left: 4px;
  margin-right: 4px;
}
.ivu-table-wrapper {
  // padding-bottom: 20px!important;
  overflow: visible !important;
}
.deleteClass {
  color: #f78989;
  // cursor:pointer;
}

.lookClass {
  color: #1890ff;
  cursor: pointer;
}

.marLeft {
  margin-left: 15px;
}
</style>
  